<template>
  <div id="comp-config-forn">
    <div id="btn-ativador">
      <v-btn
        icon
        @click="
          dialog = true;
          buscarConfigs();
        "
      >
        <v-icon small>mdi-cogs</v-icon>
      </v-btn>
    </div>
    <div id="dialog">
      <v-dialog v-model="dialog" width="580" persistent content-class="bra-20">
        <v-card>
          <v-card-title primary-title class="pl-6 py-4">
            <span>Configuração do fornecedor</span>
            <v-spacer />
            <v-btn color="#111" icon @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pt-1">
            <v-select
              v-if="fornecedor.grupo_analise_fornecedores"
              v-model="itens_fornecedores_selecionado"
              :items="itens_fornecedores"
              label="Fornecedores"
              item-text="razao_social"
              item-value="id_fornecedor"
              multiple
              chips
              small-chips
              outlined
              :clearable="!itens_fornecedores_selecionado.includes(0)"
              @change="removerTodos()"
            ></v-select>

            <v-text-field
              outlined
              v-model="configFornecedor.tempo_forecast"
              label="Previsão de Gatilho*"
              suffix="dias"
              counter="3"
              :maxlength="3"
              :error-messages="tempoForecastErrors"
              @input="$v.configFornecedor.tempo_forecast.$touch()"
              @blur="$v.configFornecedor.tempo_forecast.$touch()"
            ></v-text-field>

            <v-text-field
              outlined
              v-model="configFornecedor.pedido_minino_compra"
              label="Pedido Mínimo de Compra*"
              counter="16"
              :maxlength="16"
              prefix="R$"
              v-money="maskPedidoMinimoCompra"
              :error-messages="pedidoMininoCompraErrors"
              @input="$v.configFornecedor.pedido_minino_compra.$touch()"
              @blur="$v.configFornecedor.pedido_minino_compra.$touch()"
            ></v-text-field>

            <div class="d-flex">
              <v-col cols="6" class="pa-0 pr-2">
                <v-select
                  id="select-items-dia-data-limite"
                  v-model="itemsDiaDataLimite.value"
                  :items="itemsDiaDataLimite.items"
                  label="Selecione uma Data Limite"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  @change="mudouDataLimiteSelecionada()"
                ></v-select>
              </v-col>

              <v-col cols="6" class="pa-0 pl-2">
                <v-text-field
                  id="input-dia-data-limite-manual"
                  v-model="configFornecedor.dia_data_limite"
                  label="Informe um dia do Mês*"
                  outlined
                  type="number"
                  :disabled="itemsDiaDataLimite.value !== ''"
                  messages="Considere que o mês possui 31 dias"
                  :error-messages="diaDataLimiteErrors"
                  @input="$v.configFornecedor.dia_data_limite.$touch()"
                  @blur="$v.configFornecedor.dia_data_limite.$touch()"
                ></v-text-field>
              </v-col>
            </div>

            <v-switch
              v-model="configFornecedor.flag_cobertura_manual"
              class="mb-1"
              @click="!configFornecedor.flag_cobertura_manual && (configFornecedor.cobertura_est_manual = 0)"
            >
              <template v-slot:label>
                <span class="pl-4">Ativar cobertura manual</span>
              </template>
            </v-switch>

            <v-text-field
              v-model="configFornecedor.cobertura_est_manual"
              :disabled="!configFornecedor.flag_cobertura_manual"
              label="Cobertura de Estoque*"
              v-currency="isIntegerMask"
              outlined
              :error-messages="coberturaEstManualErrors"
              @input="$v.configFornecedor.cobertura_est_manual.$touch()"
              @blur="$v.configFornecedor.cobertura_est_manual.$touch()"
              @keyup="$event.target.value = `${$event.target.value}`.replace(/[a-zA-Z,]/g, '')"
            ></v-text-field>

            <Coberturas
              :fornecedor="fornecedor"
              @atualizar-tela-compras="$emit('atualizar-tela-compras')"
            />
          </v-card-text>

          <v-card-actions class="mt-n5">
            <v-spacer />
            <v-btn color="primary" text @click="alterarConfigs()">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <dialog-alerta-data-limite></dialog-alerta-data-limite>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import CompraAPI from "./../../../api/compra";
import dialogAlertaDataLimite from "./dialogAlertaDataLimite";
import FornecedorAPI from "../../../api/fornecedor"
import Coberturas from "../Coberturas/Index.vue";

export default {
  components: { dialogAlertaDataLimite, Coberturas },
  data: () => ({
    dialog: false,
    abudabi: 0,
    configFornecedor: {
      cobertura_est_manual: 0,
      tempo_forecast: 0,
      pedido_minino_compra: "",
      flag_cobertura_manual: "",
      dia_data_limite: 0,
    },
    itemsDiaDataLimite: {
      items: [
        { id: 0,  descricao: "Nenhum" },
        { id: 5,  descricao: "Início do Mês" },
        { id: 15, descricao: "Quinzenal" },
        { id: 31, descricao: "Fim do mês" },
        { id: '',  descricao: "Outro"}
      ],
      value: 0
    },
    maskPedidoMinimoCompra: {
      prefix: "",
      precision: 2,
    },
    isIntegerMask: {
      currency: null,
      distractionFree: { hideCurrencySymbol: false },
      precision: 0,
      allowNegative: false,
      valueAsInteger: true,
      autoDecimalMode: false,
    },
    itens_fornecedores: [],
    itens_fornecedores_selecionado: [0]
  }),

  validations: {
    configFornecedor: {
      tempo_forecast: {
        required,
        valorValido() {
          const { tempo_forecast } = this.configFornecedor;
          if (tempo_forecast > 0 && tempo_forecast <= 180) {
            return true;
          } else {
            return false;
          }
        },
      },
      pedido_minino_compra: {
        required,
        valorValido() {
          const tamanho = `${this.configFornecedor.pedido_minino_compra}`.length;

          return tamanho <= 16
        },
      },
      cobertura_est_manual: {
        required() {
          if (this.configFornecedor.flag_cobertura_manual) {
            return `${this.configFornecedor.cobertura_est_manual}`.trim().length > 0;
          } else {
            return true;
          }
        },
        valorValido() {
          if (this.configFornecedor.flag_cobertura_manual) {
            return this.configFornecedor.cobertura_est_manual && parseFloat(this.configFornecedor.cobertura_est_manual) > 0;
          } else {
            return true;
          }
        },
      },
      dia_data_limite: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(31)
      }
    },
  },
  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      fornecedor: "fornecedor/getFornecedor",
    }),
    tempoForecastErrors() {
      const errors = [];
      if (!this.$v.configFornecedor.tempo_forecast.$dirty) return errors;
      !this.$v.configFornecedor.tempo_forecast.required && errors.push("Campo Obrigatório.");
      !this.$v.configFornecedor.tempo_forecast.valorValido && errors.push("Valor mínimo é 1 e valor máximo é 180.");
      return errors;
    },
    pedidoMininoCompraErrors() {
      const errors = [];
      if (!this.$v.configFornecedor.pedido_minino_compra.$dirty) return errors;
      !this.$v.configFornecedor.pedido_minino_compra.required && errors.push("Campo Obrigatório.");
      !this.$v.configFornecedor.pedido_minino_compra.valorValido && errors.push("Valor mínimo é 1 e valor máximo é 999.999.999,99.");
      return errors;
    },
    coberturaEstManualErrors() {
      const errors = [];
      if (!this.$v.configFornecedor.cobertura_est_manual.$dirty) return errors;
      !this.$v.configFornecedor.cobertura_est_manual.required && errors.push("Campo Obrigatório.");
      !this.$v.configFornecedor.cobertura_est_manual.valorValido && errors.push("O valor mínimo é 1.");
      return errors;
    },
    diaDataLimiteErrors() {
      const errors = [];
      if (!this.$v.configFornecedor.dia_data_limite.$dirty) return errors;
      !this.$v.configFornecedor.dia_data_limite.required && errors.push("Campo Obrigatório.");
      !this.$v.configFornecedor.dia_data_limite.minValue && errors.push("Valor mínimo é 0.");
      !this.$v.configFornecedor.dia_data_limite.maxValue && errors.push("Valor máximo é 31.");
      return errors;
    },

    ANALISE_FORNECEDOR() {
      if (this.fornecedor.grupo_analise_fornecedores) {
        return this.itens_fornecedores_selecionado;
      } else {
        return this.fornecedor.id;
      }
    }
  },
  watch: {
    fornecedor () {
      this.cadastrarUltimaAnaliseFornecedor()
    }
  },
  created() {
    this.cadastrarUltimaAnaliseFornecedor()
  },
  mounted() {
    if (this.fornecedor.grupo_analise_fornecedores) this.fornecedoresSelect();
  },
  methods: {
    removerTodos() {
      if (this.itens_fornecedores_selecionado.length > 1) {
        this.itens_fornecedores_selecionado.forEach((item, i) => {
          if (item == 0) {
            this.itens_fornecedores_selecionado.splice(i, 1);
          }
        });
      } else {
        this.itens_fornecedores_selecionado = [0];
      }
    },

    fornecedoresSelect(){
      this.itens_fornecedores_selecionado = [0];

      this.$store.dispatch(
        "loading/addRequisicao",
        FornecedorAPI.buscarGrupoAnalise(this.fornecedor.id)
          .then((response) => {
            const { token, grupo } = response.data;

            localStorage.setItem("token", token);

            if (this.fornecedor.grupo_analise_fornecedores) {
              this.itens_fornecedores.push(
                {
                  id_fornecedor: 0,
                  razao_social: "Todos",
                  grupo_analise_fornecedores: true,
                  id_grupo_analise: this.fornecedor.id
                }
              );
            }

            grupo.fornecedores.forEach((f) => {
              this.itens_fornecedores.push(f);
            });
          })
          .catch(() => this.Helpers.logout())
      );
    },
    cadastrarUltimaAnaliseFornecedor () {
      const headers = this.Helpers.iniciarRequisicao()
      const params = {idfornecedor: this.fornecedor.id}

      this.$store.dispatch(
        "loading/addRequisicao",
        FornecedorAPI.setUltimaAnaliseFornecedor(headers, params)
          .then((response) => localStorage.token = response.data.token)
          .catch(() => this.Helpers.logout())
      );
    },
    mudouDataLimiteSelecionada () {
      this.configFornecedor.dia_data_limite = this.itemsDiaDataLimite.value
      this.focusDiaDataLimiteOutro()
    },
    focusDiaDataLimiteOutro () {
      if (this.configFornecedor.dia_data_limite === '') {
        const el = document.getElementById('input-dia-data-limite-manual')

        this.$v.configFornecedor.dia_data_limite.$reset()
        el.disabled = false
        el.focus()
      }
    },
    buscarConfigs () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        fornecedor: this.fornecedor.id,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getConfigsFornecedor(headers, params)
          .then((response) => {
            const {token, configs} = response.data;
            localStorage.setItem("token", token);

            let configuracao = configs;

            if (configuracao.flag_cobertura_manual == "S") {
              configuracao.flag_cobertura_manual = true;
            } else {
              configuracao.flag_cobertura_manual = false;
              configuracao.cobertura_est_manual = 0;
            }

            this.configFornecedor = configuracao;
            this.itemsDiaDataLimite.value = [0,5,15,31].includes(this.configFornecedor.dia_data_limite)
              ? this.configFornecedor.dia_data_limite
              : ''
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    alterarConfigs () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.grupoCompra,
          fornecedor: this.ANALISE_FORNECEDOR,
          forecast: this.configFornecedor.tempo_forecast,
          pedido_minino_compra: this.configFornecedor.pedido_minino_compra,
          cobertura_est_manual: this.configFornecedor.cobertura_est_manual,
          flag_cobertura_manual: this.configFornecedor.flag_cobertura_manual ? "S" : "N",
          dia_data_limite: this.configFornecedor.dia_data_limite,
          dados_fornecedor: this.fornecedor
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.setConfigsFornecedor(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.dialog = false;
              this.$emit("atualizar-tela-compras");

              // this.$store.dispatch('tabelaProduto/setProdutoClicado', new Date());
              /**
               * Raycon ficou de entender porque esse dispatch está desrrubando o usuario quando clica e salvar.
               * Na tela de compras por fornecedor na engranagem.
               */
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    close() {
      this.$v.$reset();
      this.dialog = false;
      this.itens_fornecedores_selecionado = [];
    },
  },
};
</script>
